module.exports = __webpack_public_path__ + "img/overpopulation.0e75c262.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overpopulation.jpg
// module id = EzGr
// module chunks = 0